// Scoped design tokens for the Formula Scorer dashboard, mirroring the
// consultant's standalone design (charcoal + amber, semantic state colors).
// Kept local so we match the design without touching the global MUI theme.

export const fs = {
  charcoal: "#363A44",
  amber: "#FDA42C",
  amberSoft: "#FFF5E7",
  amberLine: "#f2d29a",

  bg: "#eceef2",
  surface: "#ffffff",
  surface2: "#f6f7fa",
  line: "#e4e5ec",
  text: "#23252c",
  dim: "#71747f",
  faint: "#9a9da8",

  // semantic states
  pos: "#12925a", // gain / positive money
  posBg: "#e4f4ec",
  posLine: "#bfe3cf",
  keep: "#3f6bb0", // keep current formula
  keepBg: "#e8effa",
  keepLine: "#c6d8f2",
  muted: "#7c8290", // insufficient data
  mutedBg: "#eef0f3",
  mutedLine: "#d3d7de",
  warn: "#c26a12", // caution (high % low money)
  warnBg: "#fbecd7",
  crit: "#d0342c",

  // formula identity colors (distinguish formulas ONLY — not good/bad)
  fTeal: "#0D9488",
  fViolet: "#7C3AED",
  fMagenta: "#C026D3",
  fBrown: "#96693F",

  shadow: "0 1px 3px rgba(20,22,30,.09),0 1px 2px rgba(20,22,30,.05)",
  shadowLg: "0 8px 30px -8px rgba(20,22,30,.22)",
} as const;

// Friendly Thai labels + identity color per formula code.
export interface FormulaMeta {
  label: string;
  color: string;
}

const FORMULA_META: Record<string, FormulaMeta> = {
  SAME_DAY: { label: "สูตรวันเดียวกัน", color: fs.fTeal },
  NEXT_DAY: { label: "สูตรวันถัดไป", color: fs.fViolet },
};

export const formulaMeta = (code: string | null | undefined): FormulaMeta =>
  (code && FORMULA_META[code]) || { label: code ?? "—", color: fs.fBrown };
